import { Component, computed, input } from "@angular/core";
import { AvatarModule } from "primeng/avatar";

@Component({
  selector: 'app-user-avatar',
  templateUrl: './user-avatar.component.html',
  imports: [AvatarModule]
})
export class UserAvatarComponent {
  imageUrl = input.required<string>();
  size = input<'normal' | 'large' | 'xlarge'>('normal');

  hasImage = computed(() => this.imageUrl().startsWith('http'));
}